import React from 'react';
import {Control, Controller} from 'react-hook-form';
import {t} from '@lingui/core/macro';

import FormGroupWithError from 'shared/ui/FormGroup/FormGroupWithError';
import MultiSelectWithCheckbox from 'shared/ui/Input/MultiSelectWithCheckbox/MultiSelectWithCheckbox';

import {tagsAPI} from '../../api/tagsAPI';

interface ITagsFilterFieldProps {
    control: Control<any>,
}

const TagsFilterField: React.FC<ITagsFilterFieldProps> = ({control}) => {
    const {data: tags = []} = tagsAPI.useGetTagsQuery();

    const tagOptions = tags.map(tag => ({
        id: tag.label,
        value: tag.label,
        label: tag.label,
    }));

    return (
        <FormGroupWithError label={t`Теги`}>
            <Controller
                name="tags"
                control={control}
                render={({field, fieldState}) => (
                    <MultiSelectWithCheckbox
                        {...field}
                        options={tagOptions}
                        value={field.value ?? []}
                        onChange={(selectedTags: string[]) => field.onChange(selectedTags)}
                        placeholder={t`Выберите теги...`}
                        fieldState={fieldState}
                    />
                )}
            />
        </FormGroupWithError>
    );
};

export default TagsFilterField;
